<div class="dvb-kita-betreuungsfaktor-regel-auswahl">
    <dvb-search-get-single-entity entity-to-search="BETREUUNGSFAKTOR_REGEL"
                                  ng-model="vm.searchResultEntry"
                                  ng-change="vm.updateRegel()"
                                  display-label="COMMON.BETREUUNGSFAKTOR_REGEL.SINGULAR"
                                  placeholder-key="KINDERORT.BETREUUNGSFAKTOR_REGEL_AUSWAEHLEN"
                                  as-col="true">
    </dvb-search-get-single-entity>
</div>
